import { render, staticRenderFns } from "./NotInAllowedRoles.vue?vue&type=template&id=b28c9682&scoped=true"
import script from "./NotInAllowedRoles.vue?vue&type=script&lang=js"
export * from "./NotInAllowedRoles.vue?vue&type=script&lang=js"
import style0 from "./NotInAllowedRoles.vue?vue&type=style&index=0&id=b28c9682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28c9682",
  null
  
)

export default component.exports